import type { DateTime } from "luxon";

export function shiftHolidayToNextDay(startDateTime: DateTime, endDateTime: DateTime) {
  const lastDay = endDateTime.minus({ milliseconds: 1 }).startOf("day");
  const days = lastDay.diff(startDateTime.startOf("day"), "days").days + 1;

  return {
    startDateTime: startDateTime.plus({ days }),
    endDateTime: endDateTime.plus({ days }),
  };
}
